import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ColorSelect } from './ColorSelect';

const NETWORK_LABELS = {
  facebook: 'Facebook',
  youtube: 'YouTube',
  twitter: 'Twitter/X',
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
};

/**
 * Seccion de la tapa del PDF.
 *
 * Hay una sola maqueta, asi que no se elige plantilla: lo unico que se elige son
 * los colores, siempre de entre la paleta de marca. El logo no se elige; el PDF
 * lo pone blanco o en color segun si el fondo es oscuro o claro.
 */
export function CoverSettings({ palette, socials, value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });

  // El fondo decide el logo, igual que en el PDF: asi lo que se ve aqui es lo
  // que se va a generar.
  const darkBg = (value.cover_bg_color || '').toUpperCase() === '#333E48'
    || (value.cover_bg_color || '').toUpperCase() === '#303D48';

  const hasSocials = (value.cover_socials || []).length > 0;

  const addSocial = (network) => {
    const list = [...(value.cover_socials || [])];
    if (!network || list.some(s => s.network === network)) return;
    list.push({ network, url: '' });
    set('cover_socials', list);
  };

  const updateSocial = (network, url) => {
    set('cover_socials', (value.cover_socials || []).map(s =>
      s.network === network ? { ...s, url } : s
    ));
  };

  const removeSocial = (network) => {
    set('cover_socials', (value.cover_socials || []).filter(s => s.network !== network));
  };

  const pending = socials.filter(n => !(value.cover_socials || []).some(s => s.network === n));

  return (
    <div className="border-top border-secondary pt-3 mt-1">
      <h6 className="text-white-50 mb-3">Tapa del documento</h6>

      <div className="row g-3">
        <ColorSelect label="Color de fondo" palette={palette} value={value.cover_bg_color} onChange={v => set('cover_bg_color', v)} />
        <ColorSelect label="Color del título" palette={palette} value={value.cover_title_color} onChange={v => set('cover_title_color', v)} />
        <ColorSelect label="Color del periodo" palette={palette} value={value.cover_period_color} onChange={v => set('cover_period_color', v)} />
        <ColorSelect label="Color del separador" palette={palette} value={value.cover_rule_color} onChange={v => set('cover_rule_color', v)} />
      </div>

      <div className="text-white-50 small mt-2 mb-3">
        Logo: <strong className="text-white">{darkBg ? 'blanco' : 'gris (petróleo)'}</strong>, elegido según el fondo.
      </div>

      <div className="mt-3">
        <label className="form-label text-white-50">Descripción de la tapa</label>
        <textarea
          rows="4"
          className="form-control bg-dark text-white border-secondary py-2"
          value={value.cover_description || ''}
          onChange={e => set('cover_description', e.target.value)}
          placeholder="Texto que aparece bajo el logo en la tapa"
        />
        <div className="form-text text-white-50">
          Si dejas el texto vacío, la descripción no se imprime en el PDF.
        </div>
      </div>

      <div className="row g-3 mt-1">
        <div className="col-md-6">
          <label className="form-label text-white-50">Agregar red social</label>
          <select
            className="form-select bg-dark text-white border-secondary py-2"
            value=""
            onChange={e => addSocial(e.target.value)}
            disabled={pending.length === 0}
          >
            <option value="">
              {pending.length === 0 ? 'Todas agregadas' : 'Selecciona una red...'}
            </option>
            {pending.map(n => (
              <option key={n} value={n}>{NETWORK_LABELS[n] || n}</option>
            ))}
          </select>
        </div>
      </div>

      {hasSocials && (
        <div className="mt-3">
          {value.cover_socials.map(s => (
            <div className="d-flex gap-2 align-items-center mb-2" key={s.network}>
              <span className="badge-status status-on" style={{ minWidth: 96 }}>
                {NETWORK_LABELS[s.network] || s.network}
              </span>
              <input
                className="form-control bg-dark text-white border-secondary py-2"
                value={s.url}
                onChange={e => updateSocial(s.network, e.target.value)}
                placeholder="https://"
              />
              <button
                type="button"
                className="btn btn-ink-icon"
                onClick={() => removeSocial(s.network)}
                title="Quitar"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}